import { winnerCards } from '../data/winners';
import { handleInternalNavigation } from '../navigation';

export default function Home() {
  const featuredWinners = winnerCards.slice(0, 10);

  return (
    <section className="home-page">
      <div className="px-5 md:px-8 mx-auto max-w-7xl">
        <div className="home-hero py-14 md:py-20">
          <a href="/apply">
            <img
              src="/images/banner1.png"
              alt="Applications Open"
              className="rounded-lg shadow-lg shadow-purple-900/15"
            />
          </a>
          <a href="/apply">
            <img
              src="/images/banner2.png"
              alt="Meet the Jury"
              className="rounded-lg shadow-lg shadow-purple-900/15"
            />
          </a>
          {/* <a href="/archives/portfolio-item/heehyun-choi">
            <img
              src="/uploads/2024/06/KAFA-Banner-2024-Award-recipeint-ver-3.jpg"
              alt="KAFA Banner 2024 Award Recipient"
              className="rounded-lg shadow-lg shadow-purple-900/15"
            />
          </a> */}
          <p className="general-text">
            KAFA is Los Angeles' oldest Korean-American art non-profit organization. We support creative endeavors, encourage and nurture artistic accomplishments, and acknowledge the presence of outstanding Korean-American artists in the United States.
          </p>
          <a
            className="learn-more-button home-learn-more"
            href="/about"
            onClick={handleInternalNavigation}
          >
            Learn More
          </a>
        </div>

        <div className="home-three-col py-14 md:py-20">
          <article className="home-card">
            <div className="flex flex-col gap-4 items-center">
              <p className="general-header">About</p>
              <p className="general-text-third">
                KAFA is a 501(c)3 non-profit organization dedicated to supporting emerging Korean-American artists.
              </p>
            </div>
            <a
              className="view-more-button"
              href="/about"
              onClick={handleInternalNavigation}
            >
              View More
            </a>
          </article>

          <article className="home-card">
            <div className="flex flex-col gap-4 items-center">
              <p className="general-header">Apply</p>
              <p className="general-text-third">
                We distribute one $30,000 award biennially. Grants are made directly to artists to support their practices.
              </p>
            </div>
            <a
              className="view-more-button"
              href="/apply"
              onClick={handleInternalNavigation}
            >
              View More
            </a>
          </article>

          <article className="home-card">
            <div className="flex flex-col gap-4 items-center">
              <p className="general-header" style={{ marginBottom: '0', marginTop: '1rem' }}>
                Recipients
              </p>
              <p className="general-text-third">
                19 artists have received the KAFA Award since 1992.
              </p>
            </div>
            <a
              className="view-more-button"
              href="/recipients"
              onClick={handleInternalNavigation}
            >
              View More
            </a>
          </article>
        </div>
      </div>

      <div className="awards-band-wrap w-full">
        <div className="awards-band" aria-label="Awards">
          <p className="awards-band-title">AWARDS</p>
          <p className="awards-band-copy">One artist is awarded $30,000 biennially.</p>
        </div>
      </div>

      <section className="winners-section w-full" aria-labelledby="winners-heading">
        <div className="winners-grid">
          {featuredWinners.map((winner) => (
            <a
              key={winner.id}
              href={winner.href}
              className={`winner-card ${winner.span === 'wide' ? 'winner-card-wide' : ''}`}
              aria-label={`${winner.year} ${winner.media} by ${winner.name}`}
            >
              <img className="winner-card-image" src={winner.image} alt="" />
              <div className="winner-card-overlay">
                <div className="winner-card-portrait-wrap">
                  <img className="winner-card-portrait" src={winner.portrait} alt="" />
                </div>
                <div className="winner-card-copy">
                  <span className="winner-card-meta">{winner.year} | {winner.media}</span>
                  <span className="winner-card-name">{winner.name}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </section>
  );
}
